module.exports = __webpack_public_path__ + "img/card-2_mob.0ea8b27f.png";